<template>
  <div class="user">
    <div class="user_head">{{ $t('message.my.me') }}</div>
    <div class="user_information">
      <div class="user_information_img" @click="editUserClick" v-if="isShow">
        <i class="icon-jr-icon-edit iconfont"></i>
      </div>
      <img :src="userInfo.headImgUrl" alt="" v-if="isShow && userInfo.headImgUrl" />
      <img v-else src="../../../static/image/nan.png" alt="" />

      <p v-if="isShow">{{ userInfo.nickName }}</p>
      <p v-else @click="loginClick">{{ $t('message.my.log') }}</p>
    </div>
    <div class="user_item">
      <div class="user_item_ul">
        <div class="user_item_ul_li" @click="myWorksClcik">
          <div class="user_item_ul_li_top">
            <i class="iconfont icon-jr-icon-folder"></i>
            <span>{{ $t('message.my.entry') }}</span>
          </div>
          <div class="user_item_ul_li_bottom">
            <span v-if="isShow && userInfo.works">{{ userInfo.works }}</span>
            <span v-else>0</span>
          </div>
        </div>
        <!-- myWorksClcik +s -->
        <div class="user_item_ul_li" @click="myWorksClciks">
          <div class="user_item_ul_li_top">
            <i class="iconfont icon-jr-icon-badge1"></i>
            <span>{{ $t('message.my.prize') }}</span>
          </div>
          <div class="user_item_ul_li_bottom">
            <span v-if="isShow && userInfo.works">{{ userInfo.awards }}</span>
            <span v-else>0</span>
          </div>
        </div>
        <div class="user_item_ul_li" @click="myAwardClick">
          <div class="user_item_ul_li_top">
            <img src="../../../static/image/zhengshu.png" alt="" class="zhengshu" />
            <span>{{ $t('message.my.certificate') }}</span>
          </div>
          <div class="user_item_ul_li_bottom">
            <span v-if="isShow && userInfo.certificateNum">{{ userInfo.certificateNum }}</span>
            <span v-else>0</span>
          </div>
        </div>
      </div>
    </div>
    <div class="user_inform">
      <!-- 实名认证 -->
      <!-- <div class="user_inform_item" @click="ToCertification">
        <div class="user_inform_item_mask">
          <img src="../../../static/image/jr-icon-shield.png" alt="" />
        </div>
        <div class="user_inform_item_text">
          {{ $t('message.my.certification') }}

          <div class="not_certified" v-if="authenticationState == 1">未认证</div>
          <div class="not_certified" v-else-if="authenticationState == 2">审核中</div>
          <div class="not_certified" v-else-if="authenticationState == 3">已认证</div>
        </div>
        <div class="user_inform_item_right">
          <van-icon name="arrow" color="#BBCCD6" size="18" />
        </div>
      </div> -->

      <div class="user_inform_item" @click="toSing">
        <div class="user_inform_item_mask">
          <img src="../../../static/image/jr-icon-name.png" alt="" />
        </div>
        <!-- <div class="user_inform_item_text">签约申请</div> -->
        <div class="user_inform_item_text">{{ $t('message.my.signingCertification') }}</div>
        <div class="user_inform_item_right">
          <van-icon name="arrow" color="#BBCCD6" size="18" />
        </div>
      </div>

      <div class="user_inform_item" @click="toMyNews">
        <div class="user_inform_item_mask">
          <img src="../../../static/image/2684.png" alt="" />
        </div>
        <div class="user_inform_item_text">
          {{ $t('message.my.myNews') }}
          <div class="not_certified">{{ journalismNum }} {{ $t('message.my.manuscript') }}</div>
        </div>
        <div class="user_inform_item_right">
          <van-icon name="arrow" color="#BBCCD6" size="18" />
        </div>
      </div>

      <!-- 消息通知 -->
      <div class="user_inform_item" @click="ToInform">
        <div class="user_inform_item_mask">
          <van-icon name="chat-o" size="20" color="#3562FF" />
        </div>
        <div class="user_inform_item_text">
          {{ $t('message.my.messages') }}
          <div class="user_inform_item_hint" v-show="sum >= 1">
            <!-- {{ userInfo.sum }} -->
            <span v-if="sums">{{ sum }}</span>
            <span v-else>99+</span>
          </div>
        </div>

        <div class="user_inform_item_right">
          <van-icon name="arrow" color="#BBCCD6" size="18" />
        </div>
      </div>

      <!-- 问题反馈 -->
      <div class="user_inform_item" @click="problemFeedback">
        <div class="user_inform_item_mask">
          <van-icon name="question-o" size="20" color="#3562FF" />
        </div>
        <div class="user_inform_item_text">
          <!-- {{ $t('message.my.messages') }} -->
          {{ $t('message.home.Feedback') }}
          <div class="user_inform_item_hint" v-show="sum >= 1">
            <span v-if="sums">{{ sum }}</span>
            <span v-else>99+</span>
          </div>
        </div>

        <div class="user_inform_item_right">
          <van-icon name="arrow" color="#BBCCD6" size="18" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getCookie } from '@/utils/cookie'
import { NewsListCount, selectIsAuthentication } from '@/api/journalism.js'
import { apiUser } from '@/api/user.js'
export default {
  name: 'User',
  data() {
    return {
      isShow: false,
      userInfo: {},
      sums: true,
      sum: 0,
      journalismNum: 0,
      authenticationState: 1
    }
  },
  created() {
    let token = getCookie('token')
    if (token) {
      this.getUser()
      this.getNewsListCount()
      this.getAuthentication()
      this.isShow = true
    } else {
      this.isShow = false
    }
  },
  methods: {
    editUserClick() {
      this.$router.push({
        name: 'EditUser'
      })
    },
    async getNewsListCount() {
      let query = {
        appId: getCookie('userId'),
        endTime: '',
        explain: '',
        isDelete: '1',
        isEaveInformation: '',
        isNewsPool: '',
        isPutaway: '',
        isRecommend: '',
        isSendBack: '0',
        isTop: '',
        manuscriptStatus: '',
        manuscriptType: '',
        newsCity: '',
        newsClassification: '',
        newsClassifications: null,
        newsCode: '',
        newsProvince: '',
        newsTitle: '',
        nickName: '',
        order: 'desc',
        orderType: '1',
        organizationId: 0,
        realName: '',
        startTime: ''
      }
      const { data: res } = await NewsListCount(query)
      if (res.resultCode == 200) {
        // console.log(res.data[0].count)
        this.journalismNum = res.data[0].count
      }
    },
    myAwardClick() {
      // Toast('敬请期待')
      if (this.isShow) {
        this.$router.push({
          name: 'certificate'
        })
      } else {
        Toast.fail(this.$t('message.my.logged'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      }
    },
    // 获取认证状态
    async getAuthentication() {
      let userId = getCookie('userId')
      const { data: res } = await selectIsAuthentication({
        appId: userId
      })
      if (res.resultCode == 200) {
        console.log(res.data)
        if (res.data) {
          this.authenticationState = res.data
        }
      }
    },
    myWorksClciks() {
      //Toast('敬请期待')
      if (this.isShow) {
        this.$router.push({
          name: 'awlist'
        })
      } else {
        Toast.fail(this.$t('message.my.logged'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      }
    },
    myWorksClcik() {
      if (this.isShow) {
        this.$router.push({
          name: 'UserWorks'
        })
      } else {
        Toast.fail(this.$t('message.my.logged'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      }
    },
    loginClick() {
      if (!this.isShow) {
        Toast.fail(this.$t('message.my.logged'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      }
    },
    // 签约申请
    toSing() {
      if (!this.isShow) {
        Toast.fail(this.$t('message.my.logged'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      } else {
        this.$router.push({
          // path: '/user/applicationPhotography'
          path: '/user/certification'
        })
      }
    },
    async getUser() {
      const { data: res } = await apiUser()
      // console.log(res)
      if (res.resultCode === 200) {
        this.userInfo = res.data
      }
      this.sum = this.userInfo.sum
      //console.log(this.userInfo.sum)
      if (this.sum > 99) {
        this.sums = false
      }
    },

    ToInform() {
      // Toast('敬请期待')
      // 点击跳转到消息列表
      this.$router.push({
        name: 'messageList'
      })
    },
    ToCertification() {
      if (!this.isShow) {
        Toast.fail(this.$t('message.my.logged'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      } else {
        this.$router.push({
          path: '/user/certification'
        })
      }
    },
    toMyNews() {
      if (!this.isShow) {
        Toast.fail(this.$t('message.my.logged'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      } else {
        this.$router.push({
          path: '/user/myNews'
        })
      }
    },

    // 问题反馈
    problemFeedback() {
      window.open('https://support.qq.com/product/466423')
      // console.log('问题反馈')
    }
  },
  computed: {}
}
</script>

<style lang="less" scoped>
.user {
  width: 100%;
  overflow: auto;
  box-sizing: border-box;
  // height: 100vh;
  background-size: 100% 274px;
  background-image: url('../../../static/image/user_bjt.png');
  background-repeat: no-repeat;

  .user_head {
    width: 100%;
    text-align: center;
    height: 56px;
    line-height: 56px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    position: fixed;
    top: 0;
    left: 0;
  }

  .user_information {
    width: 100%;
    margin-top: 80px;
    box-sizing: border-box;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;

    .user_information_img {
      width: 30px;
      height: 30px;
      border-radius: 4px;
      display: flex;
      position: absolute;
      right: 30px;
      top: 0;
      align-items: center;
      justify-content: center;
      background: #deebff;

      i {
        font-size: 12px;
        color: #2e3e5c;
      }
    }

    img {
      width: 68px;
      height: 68px;
      border-radius: 50%;
    }

    p {
      margin: 6px auto;
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .user_item {
    width: 100%;
    box-sizing: border-box;
    border-radius: 30px 30px 0 0;
    background-color: #ffffff;
    padding: 20px 30px;
    height: 100px;

    .user_item_ul {
      width: 100%;
      height: 75px;
      margin-top: -50px;
      background-color: #ffffff;
      box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.14);
      border-radius: 6px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .user_item_ul_li {
        width: 50%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .user_item_ul_li_top {
          margin: 6px auto;

          i {
            font-size: 16px;
            margin-right: 2px;
            color: #3562ff;
          }

          .zhengshu {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }

          span {
            font-size: 12px;
            color: #757897;
            font-weight: 400;
          }
        }

        .user_item_ul_li_bottom {
          color: #263245;
          font-weight: 500;
          font-size: 20px;

          span {
            color: #263245;
            font-weight: 500;
            font-size: 20px;
          }
        }
      }
    }
  }

  .user_inform {
    box-sizing: border-box;
    width: 100%;
    margin-top: -40px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .user_inform_item {
      position: relative;
      box-sizing: border-box;
      width: 325px;
      height: 72px;
      border: 0.5px solid rgba(0, 0, 0, 0.2);
      border-radius: 14px;
      display: flex;
      padding-left: 19px;
      align-items: center;
      margin-bottom: 10px;
      cursor: pointer;

      .user_inform_item_mask {
        width: 38px;
        height: 38px;
        background-color: rgba(53, 98, 255, 0.2);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .user_inform_item_text {
        margin-left: 8px;
        color: #1a1a1a;
        position: relative;

        .not_certified {
          font-size: 12px;
          color: #757897;
        }
      }

      .user_inform_item_hint {
        position: absolute;
        top: 0px;
        right: -20px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #f83e3e;
        text-align: center;
        line-height: 20px;
        font-size: 11px;
        margin-left: 4px;
        text-align: center;
        color: #fff;
      }

      .user_inform_item_right {
        position: absolute;
        right: 26px;
      }
    }
  }
}
</style>
